
var uploadLess = {};
import genaration from '../../utils/classname';
export var uploadClass = genaration(uploadLess, 'upload');